var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOnline),expression:"!isOnline"}],staticClass:"text-red",attrs:{"size":"lg","name":"wifi_off"}})}
var staticRenderFns = []

export { render, staticRenderFns }